import { jsx as _jsx } from "react/jsx-runtime";
import { renderToString } from "react-dom/server";
import { UserMarkerInfoWindow } from "../../../../components/StoreLocator/components/UserMarkerInfoWindow";
import { USER_LOCATION } from "../../../../components/StoreLocator/store-locator-icons";
import styles from "./yandexStyles.module.scss";
export const YANDEX_DIRECTION_URL_CONST = "https://yandex.com/maps/?ll=&mode=routes&rtext=~";
export const MARKER_SOURCE = "marker-source";
export const DESKTOP_BREAKDOWN = 768;
export const getCustomMarker = (store, iconFactory) => {
    const { id } = store;
    const markerImage = document.createElement("img");
    markerImage.setAttribute("data-storetype", store.storetype);
    markerImage.setAttribute("id", `marker-${id}`);
    markerImage.classList.add(`${styles.yandexStoreMarker}`);
    const icon = iconFactory(store);
    markerImage.src = icon.default;
    return markerImage;
};
export const getYandexDirectionUrl = (store) => `${YANDEX_DIRECTION_URL_CONST}${store.Location.lat},${store.Location.lon}&rtt=auto&ruri=~&z=12`;
export const mapStoresPoints = (stores) => {
    return stores.map((store) => ({
        type: "Feature",
        id: store.id,
        geometry: { type: "Point", coordinates: [store.Location.lon, store.Location.lat] },
        properties: { store },
    }));
};
export const updateStoreElements = (source, iconFactory, storeId) => {
    const markerImages = document.querySelectorAll(`.${styles.yandexStoreMarker}`);
    markerImages.forEach((img) => {
        const storetype = img.dataset.storetype;
        const icon = iconFactory({ storetype });
        img.setAttribute("src", icon.default);
    });
    if (storeId && source === MARKER_SOURCE) {
        const activeMarker = document.getElementById(`marker-${storeId}`);
        const storetype = activeMarker.dataset.storetype;
        const icon = iconFactory({ storetype });
        if (activeMarker) {
            activeMarker.setAttribute("src", icon.active);
        }
    }
};
export const getUserLocationMarker = () => {
    const markerImage = document.createElement("img");
    markerImage.classList.add(`${styles.yandexStoreMarker}`);
    markerImage.src = USER_LOCATION;
    return markerImage;
};
export const getUserLocationPopup = () => {
    const userLocationInfoPopupHTML = renderToString(_jsx(UserMarkerInfoWindow, {}));
    const popupContainerElement = document.createElement("div");
    popupContainerElement.classList.add(`${styles.yandexPopupContainer}`, `${styles.yandexPopupContainerActive}`);
    popupContainerElement.innerHTML = userLocationInfoPopupHTML;
    return popupContainerElement;
};
export const createClusterer = ({ layoutVersion }) => {
    if (layoutVersion !== "v2") {
        return getClustererCircle;
    }
    return getClustererCircleV2;
};
export const getClustererCircle = (count) => {
    const circle = document.createElement("div");
    const fill = count > 10 ? "#ff0000" : "#0000ff";
    circle.classList.add(`${styles.yandexClustererCircle}`);
    circle.innerHTML = `
     <svg width="50" height="50" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" fill=${fill} transform="translate(0 25)">
        <circle cx="120" cy="120" opacity="0.6" r="70"></circle>
        <circle cx="120" cy="120" opacity="0.3" r="90"></circle>
        <circle cx="120" cy="120" opacity="0.2" r="110"></circle>
        <text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle">${count}</text>
    </svg>
 `;
    return circle;
};
export const getClustererCircleV2 = (count) => {
    const circle = document.createElement("div");
    circle.classList.add(`${styles.yandexClustererCircleV2}`);
    circle.innerHTML = `
     <svg width="40" height="40" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
        <circle cx="20" cy="20" r="19"></circle>
        <text x="50%" y="50%">${count}</text>
    </svg>
 `;
    return circle;
};
export const updateDropdownContainer = () => {
    const dropdownContainer = document.getElementById("dropdown-container");
    if (dropdownContainer) {
        dropdownContainer.remove();
    }
};
export const createSuggestionItems = (inputRef, suggestions, handleInputSearchClick) => {
    updateDropdownContainer();
    const dropdownContainer = document.createElement("div");
    dropdownContainer.setAttribute("id", "dropdown-container");
    dropdownContainer.classList.add(`${styles.yandexDropdownContainer}`);
    inputRef.current.parentNode.appendChild(dropdownContainer);
    suggestions.forEach((suggestion) => {
        const item = document.createElement("div");
        item.classList.add(`${styles.yandexDropdownItem}`);
        item.innerText = suggestion.value;
        dropdownContainer.appendChild(item);
        item.addEventListener("click", () => {
            inputRef.current.value = suggestion.value;
            handleInputSearchClick();
            updateDropdownContainer();
        });
    });
    return dropdownContainer;
};
//# sourceMappingURL=utils.js.map